import React from "react";

import SEO from '../components/SEO';

const title = "Contact Us | AKHSoft";
const description = "Get in touch with AKHSoft for expert software development, ERP solutions, web design, and digital marketing services. We're here to help you grow your business.";
const keywords = "AKHSoft contact, software company contact, ERP support, web development inquiry, digital marketing help, contact software agency";
const path = typeof window !== "undefined" ? window.location.pathname : "";
const ContactUs = () => {
  return (
    <>
     <SEO 
      title={title}
      description={description}
      keywords={keywords}
      path={path}
    />
   
    <div className="min-h-screen p-6 bg-white text-gray-800">
        
      {/* Hero Section */}
      <div className="bg-[#0a3c6d] py-20 text-white text-center px-4">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Contact Us</h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto">
          Ready to take your business to the next level? Reach out to AKHSoft — your trusted partner for custom software, web development, and digital solutions. Let’s discuss your project and build something great together.
        </p>
      </div>
      <h1 className="text-3xl font-bold mb-6 text-center">Contact Us</h1>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Google Map */}
        <div className="w-full h-[400px]">
          <iframe
            className="w-full h-full rounded-lg shadow"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.927006189267!2d67.03493181542733!3d24.84732815106545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1234567890abcdef!2sAKHSoft%20Headquarters!5e0!3m2!1sen!2s!4v1615245937032!5m2!1sen!2s"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        {/* Contact Form */}
        <form
          className="space-y-4"
          action="https://yourdomain.com/contact.php"
          method="POST"
        >
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            className="w-full border border-gray-300 p-3 rounded"
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            className="w-full border border-gray-300 p-3 rounded"
          />
          <input
            type="text"
            name="subject"
            placeholder="Subject"
            className="w-full border border-gray-300 p-3 rounded"
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            required
            className="w-full border border-gray-300 p-3 rounded"
          ></textarea>
          <button
            type="submit"
            className="bg-[#0a3c6d] text-white px-6 py-2 rounded hover:bg-blue-800"
          >
            Send Message
          </button>
        </form>
      </div>

      {/* Contact Details */}
   <div className="mt-10 bg-gray-50 p-8 rounded-xl shadow-lg max-w-xl mx-auto">
  <h2 className="text-3xl font-bold text-[#0a3c6d] mb-6 border-b-2 border-[#0a3c6d] pb-2 text-center">
    Contact Information
  </h2>

  <div className="space-y-4 text-gray-800 text-base">
    <div className="flex items-center space-x-3">
      <span className="text-xl">📍</span>
      <p><strong>Address:</strong>  Karachi, Pakistan</p>
    </div>

    <div className="flex items-center space-x-3">
      <span className="text-xl">📞</span>
      <p><strong>Phone:</strong> +92 343 2998052</p>
    </div>

    <div className="flex items-center space-x-3">
      <span className="text-xl">📧</span>
      <p><strong>Email:</strong> info@akhsoft.com</p>
    </div>

    <div className="flex items-center space-x-3">
      <span className="text-xl">🌐</span>
      <p><strong>Website:</strong> <a href="https://www.akhsoft.com" className="text-[#0a3c6d] hover:underline">www.akhsoft.com</a></p>
    </div>
  </div>
</div>


    </div>
     </>
  );
};

export default ContactUs;
